import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { DATOS_API } from 'app/auth/auth.datos';

@Injectable({
  providedIn: 'root'
})

export class RequirementsService {

  // private ip = 'http://35.232.140.117:3800';

  constructor(
    private httpClient: HttpClient
  ) { }


  public registerManagerTI(idCompany,data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.requirements.responsableTI+idCompany, data);
    // return this.httpClient.post(this.ip+'/api_empresa/responsableTI/'+idCompany, data,
    //{ headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public getBanderas(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.getBaderasEncuesta+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Certificar/secciones/get/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }

  public setBandera(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.setBaderasEncuesta+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Certificar/secciones/get/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }
  public setBanderaFocus(data){

    return this.httpClient.post(DATOS_API.url + DATOS_API.endpoints.Focus.updateRequerimientosFocus+this.getCompanyID(),data);
    // return this.httpClient.post(this.ip+'/api_empresa/Certificar/secciones/get/'+this.getCompanyID(),data,
    // { headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  public getManagerTI(idCompany){

    return this.httpClient.get(DATOS_API.url + DATOS_API.endpoints.getInfoTI+idCompany);
    // return this.httpClient.get(this.ip+'/api_empresa/responsableTI/'+idCompany,
    //{ headers: new HttpHeaders({'Authorization': 'Bearer ' + this.getToken()})});
  }


  ////////////////OBTIENE EL TOKEN DEL USUARIO EN LINEA
  private getToken():string{
    const token = localStorage.getItem('token');

    return token;
  }

  public bandera_getCompanyID():string{
    const token = localStorage.getItem('companyID');

    return token;
  }

  private getCompanyID():string{
    const token = localStorage.getItem('companyID');

    return token;
  }



}
